import * as React from 'react';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIList from 'UIComponents/list/UIList';
import ReenrollmentSelect from 'automation-ui-enrollment/components/ReenrollmentSelect';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ScheduledEnrollmentReenrollmentTab = ({
  flowObjectTypeId
}) => {
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs(NavMarker, {
      name: "SCHEDULED_RE_ENROLLMENT_PANEL",
      children: [/*#__PURE__*/_jsx(ReenrollmentSelect, {
        readOnly: true,
        shouldReenroll: true,
        setShouldReenroll: () => {},
        objectTypeId: flowObjectTypeId,
        reenrollDescription: /*#__PURE__*/_jsxs(UIList, {
          styled: true,
          className: "p-left-5",
          children: [/*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "automation-ui-enrollment.redesign.review.manualReenrollment"
            })
          }), /*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "automation-ui-enrollment.redesign.scheduledTriggers.tabs.reenrollment.qualifications.filterCriteria"
            })
          })]
        })
      }), /*#__PURE__*/_jsx(UIAlert, {
        className: "m-y-3",
        type: "warning",
        titleText: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
          baseLangKey: "automation-ui-enrollment.redesign.scheduledTriggers.tabs.reenrollment.alert_title_cob",
          elements: {
            b: 'b'
          },
          objectTypeId: flowObjectTypeId,
          isJsx: true
        }),
        children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
          baseLangKey: "automation-ui-enrollment.redesign.scheduledTriggers.tabs.reenrollment.alert_description_cob",
          elements: {
            b: 'b'
          },
          objectTypeId: flowObjectTypeId,
          isJsx: true
        })
      })]
    })
  });
};
export default ScheduledEnrollmentReenrollmentTab;